import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  defaultDomain: 'https://durgahifashions.com/api',
  queryDomain: '',
}

const domainSlice = createSlice({
  name: 'domain',
  initialState,
  reducers: {
    setQueryDomain: (state, action) => {
      state.queryDomain = action.payload
    },
    resetQueryDomain: state => {
      state.queryDomain = ''
    },
  },
})

export const { setQueryDomain, resetQueryDomain } = domainSlice.actions
export default domainSlice.reducer
